var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7222CB87-9FA4-48D9-8122-124A817095F2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prospecting",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospect-Details--Create-Sales-Plan",
    transform: "translate(-1342.5367, -10.3811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notifications",
    transform: "translate(1342.5367, 10.3811)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 19,
    cy: 19,
    r: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9999114,30.1936996 C20.7514093,30.1936996 22.2165689,28.9451088 22.5530208,27.2924215 L15.4468021,27.2924215 C15.7834311,28.9451088 17.2485907,30.1936996 18.9999114,30.1936996 Z M19.0000886,6.98347543 C19.5338075,6.98347543 19.9671222,7.41572759 19.9671222,7.95050906 L19.9671222,8.99510374 C23.2427472,9.46702182 25.7696782,12.2841869 25.7696782,15.6873095 L25.7696782,18.3835289 C25.7696782,19.2975366 25.9609098,20.1870699 26.3209417,21.0025022 C26.5868783,21.5920512 26.9328624,22.1434761 27.3584655,22.6361275 C27.3666906,22.6461281 27.3751603,22.6558251 27.3836609,22.6654997 L27.3584655,22.6361275 C27.4193983,22.7066595 27.4819631,22.7759868 27.546142,22.8440493 L27.3836609,22.6654997 C27.4652546,22.7583616 27.5496947,22.8491541 27.6369239,22.9377505 L27.546142,22.8440493 C27.6060599,22.9075928 27.6673846,22.9700338 27.7301017,23.0313234 L27.6369239,22.9377505 C27.7772008,23.0802262 27.9246907,23.2170223 28.079155,23.3476113 C28.3299002,23.5623503 28.5093413,23.8419399 28.601108,24.1511739 L28.6395026,24.3080148 C28.6603052,24.4141442 28.6709562,24.522832 28.6709562,24.6328577 C28.6709562,25.5662461 27.9118144,26.3253879 26.978426,26.3253879 L11.0213969,26.3253879 C10.0881856,26.3253879 9.32904376,25.5662461 9.32904376,24.6328577 C9.32904376,24.1377421 9.54472713,23.6697198 9.920845,23.3476113 C10.0413841,23.2457038 10.1576759,23.1400163 10.2696071,23.0307996 C10.3011651,23.0007682 10.3320859,22.9699269 10.3626589,22.9388054 L10.2696071,23.0307996 C10.332465,22.969466 10.3939477,22.9070194 10.4540352,22.8435043 L10.3626589,22.9388054 C10.4499927,22.8499046 10.5344879,22.7587181 10.6161027,22.6653873 L10.4540352,22.8435043 C10.5182056,22.7756732 10.5807847,22.7066234 10.6417481,22.6364088 L10.6161027,22.6653873 C11.053372,22.1653466 11.4079564,21.6037533 11.6734053,21.0023644 C12.0390902,20.1870699 12.2303218,19.2975366 12.2303218,18.3835289 L12.2303218,15.6873095 C12.2303218,12.2841869 14.7572528,9.46702182 18.0328778,8.99510374 L18.0328778,7.95050906 C18.0328778,7.41572759 18.4661925,6.98347543 18.9999114,6.98347543 Z",
    id: "Combined-Shape",
    fill: "#A28014",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.dff7433b18a766c9bbef69c74332d6c3.svg";
export { ForwardRef as ReactComponent };